import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';



export const labelValueStyles = makeStyles((theme) => ({
    labelViewRow: {
        '& .row-header': {
            paddingRight: theme.spacing(1),
            '&.full-span': {
                justifyContent: 'space-between',
            },
        },
        '& .row-header-text': {
            display: 'inline',
            
        },
        '& .row-tooltip': {
            display: 'inline-block',
            paddingLeft: theme.spacing(.5),
        },

    },

    labelRowContainer: { // creates alternating rows 
        '& > div': {
            marginBottom: '0',
            padding: theme.spacing(.5),
            '&:nth-child(even)': {
                background: tcsmColors.greySix,
                
            },
        },
        '& .row-header': {
            display: 'flex',
        },
    },


}));




